import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import PreviousPage from "../Util/PreviousPage";
import NoImageFound from "../Util/NoImageFound";
import Sorting from "../Util/Sorting";
import Skeleton from "react-loading-skeleton";
import { propertyListing, getPropertyDetailsbyId } from "../../../api/idx";
import ProductListing from "../Components/ProductListing";
import arrow from "../../../assets/icons/Arrow Down.svg";
import { handdleAscending, handdleDescending } from "../../../util/sorting";
const ViewSimilarProperties = () => {
  const [listing, setListing] = useState<any>([]);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagescountstartend, setPagesCountStartend] = useState({
    start: 1,
    end: 20,
  });
  const [loading, setLoading] = useState(false);
  const [selectedSort, setSelectedSort] = useState("new_listing");
  const [sortingPara, setSortingPara] = useState({
    new_listing: true,
    highest_price: null,
    lowest_price: null,
    year_built: null,
    open_house_date: null,
    recently_reduced: null,
    largest_sqft: null,
    lot_size: null,
  });

  const history = useHistory();
  const params: any = useParams();

  useEffect(() => {
    async function anonymous() {
      setLoading(true);
      let response = await getPropertyDetailsbyId(params?.id);
      let custom_filter = {
        city: response?.[0]?.City,
        country: response?.[0]?.Country,
        stateOrProvince: response?.[0]?.StateOrProvince,
        pageSize: 20,
        pageNo: currentPage,
        ...sortingPara,
      };

      // @ts-ignore
      let listing: any = await propertyListing(custom_filter);
    //   let filtered_array = listing?.value?.filter(
    //     (v: any) => v?.listingid !== params?.id
    //   );

    //   setListing(filtered_array);
        setListing(listing?.value);
      setCount(listing?.odatacount);
      setLoading(false);
    }
    anonymous();
  }, [currentPage,sortingPara]);

  const handleValue = async (e: any, data: any) => {
    e.preventDefault();
    history.push(`/singleproduct/${data?.listingid}`);
  };

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
    setPagesCountStartend({
      start: pagescountstartend.start + 20,
      end:
        count < pagescountstartend.end + 20
          ? count
          : pagescountstartend.end + 20,
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
    setPagesCountStartend({
      start: pagescountstartend.start - 20,
      end: pagescountstartend.end - 20,
    });
    window.scrollTo({
      top: 0,

      behavior: "smooth",
    });
  };

  const handleSorting = (type: string) => {
    if (type === "ascending") {
      let sorted_data = handdleDescending(listing);
      setListing(sorted_data);
    }
    if (type === "descending") {
      let sorted_data = handdleAscending(listing);
      setListing(sorted_data);
    }
  };

  const handleChangeSortingPara = (e) => {
    setSelectedSort(e.target.value)
    switch (e.target.value) {
      case "lowest_price":
        setSortingPara({
          new_listing: null,
          highest_price: null,
          lowest_price: true,
          year_built: null,
          open_house_date: null,
          recently_reduced: null,
          largest_sqft: null,
          lot_size: null,
        });
        break;

      case "highest_price":
        setSortingPara({
          new_listing: null,
          highest_price: true,
          lowest_price: null,
          year_built: null,
          open_house_date: null,
          recently_reduced: null,
          largest_sqft: null,
          lot_size: null,
        });
        break;

      case "year_built":
        setSortingPara({
          new_listing: null,
          highest_price: null,
          lowest_price: null,
          year_built: true,
          open_house_date: null,
          recently_reduced: null,
          largest_sqft: null,
          lot_size: null,
        });
        break;

      case "open_house_date":
        setSortingPara({
          new_listing: null,
          highest_price: null,
          lowest_price: null,
          year_built: null,
          open_house_date: true,
          recently_reduced: null,
          largest_sqft: null,
          lot_size: null,
        });
        break;

      case "recently_reduced":
        setSortingPara({
          new_listing: null,
          highest_price: null,
          lowest_price: null,
          year_built: null,
          open_house_date: null,
          recently_reduced: true,
          largest_sqft: null,
          lot_size: null,
        });
        break;

      case "largest_sqft":
        setSortingPara({
          new_listing: null,
          highest_price: null,
          lowest_price: null,
          year_built: null,
          open_house_date: null,
          recently_reduced: null,
          largest_sqft: true,
          lot_size: null,
        });
        break;

      case "lot_size":
        setSortingPara({
          new_listing: null,
          highest_price: null,
          lowest_price: null,
          year_built: null,
          open_house_date: null,
          recently_reduced: null,
          largest_sqft: null,
          lot_size: true,
        });
        break;

      default:
        setSortingPara({
            new_listing: true,
            highest_price: null,
            lowest_price: null,
            year_built: null,
            open_house_date: null,
            recently_reduced: null,
            largest_sqft: null,
            lot_size: null,
          });
        break;
    }
  };

  return (
    <>
      {!loading ? (
        <section
          className={
            listing?.length == undefined || listing?.length == 0
              ? "favourite withError"
              : "favourite"
          }
          id="favourite"
        >
          {(listing?.length == undefined || listing?.length == 0) && (
            <NoImageFound />
          )}
          {/* <PreviousPage listing={listing} /> */}
          <div
            className="back profile-arrow-back"
            onClick={() => history.push(`/singleproduct/${params?.id}`)}
          >
            <img src={arrow} className="arrow-Back" alt="back_arrow" />
          </div>
          <div className="container-fluid custom-container">
            <div className="col-md-12">
              <h1 className="favourite-title">Similar Properties</h1>
              <div className="d-flex justify-content-between sortingDD mb-3">
                <h4 className="product-title">{count} results</h4>
                <div className="sorting">
                      <select
                        name=""
                        id=""
                        className="form-select mr-2"
                        onChange={(e) => handleChangeSortingPara(e)}
                        value={selectedSort}
                      >
                        <option value="" hidden>
                          Sort
                        </option>
                        <option value="new_listing">Newest listings</option>
                        <option value="lowest_price">Lowest price</option>
                        <option value="highest_price">Highest price</option>
                        <option value="year_built">Year built</option>
                        <option value="open_house_date">Open house date</option>
                        <option value="recently_reduced">
                          Recently reduced
                        </option>
                        <option value="largest_sqft">Largest sqft</option>
                        <option value="lot_size">Lot size</option>
                        {/* <option value="">None</option> */}
                      </select>
                      <span className="mr-2">Sort</span>
                      <div onClick={() => handleSorting("ascending")}>
                        <span>
                          <i className="fa-solid fa-arrow-down"></i>
                        </span>
                      </div>
                      <div onClick={() => handleSorting("descending")}>
                        <span>
                          <i className="fa-solid fa-arrow-up"></i>
                        </span>
                      </div>
                    </div>
              </div>
            </div>

            <div className="row">
              {listing && listing?.length > 0
                ? listing?.map((v: any) => {
                    return (
                      <div
                        className="col-lg-3 col-md-6"
                        onClick={(e) => handleValue(e, v)}
                      >
                        <ProductListing
                          propertylisting={v}
                          currentPage={currentPage}
                        />
                      </div>
                    );
                  })
                : ""}
            </div>
            {listing?.length > 0 ? (
              <div className="productpagination">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className="productlistPrev"
                >
                  Previous
                </button>
                <span>
                  Showing {pagescountstartend.start} -{" "}
                  {pagescountstartend.end >= count
                    ? count
                    : pagescountstartend.end}{" "}
                  of {count} {/* of {count} */}
                </span>
                <button
                  onClick={nextPage}
                  disabled={pagescountstartend.end >= count}
                  className="productlistNext"
                >
                  Next
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
          {/* <Pagination listing={listing} setCurrentItems={setCurrentItems} /> */}
        </section>
      ) : (
        <section className="favourite mb-5" id="favourite">
          <div className="container-fluid custom-container">
            <Skeleton width={50} />
            <div className="d-flex justify-content-between">
              <Skeleton width={50} />
              <Skeleton width={50} />
            </div>

            <div className="row">
              <div className="col-lg-3 col-md-6">
                <Skeleton height={400} />
              </div>
              <div className="col-lg-3 col-md-6">
                <Skeleton height={400} />
              </div>
              <div className="col-lg-3 col-md-6">
                <Skeleton height={400} />
              </div>
              <div className="col-lg-3 col-md-6">
                <Skeleton height={400} />
              </div>
            </div>
          </div>
          {/* <Pagination listing={listing} setCurrentItems={setCurrentItems} /> */}
        </section>
      )}
    </>
  );
};

export default ViewSimilarProperties;


